import React from 'react';
import classNames from 'classnames';
import './PlaylistPreviewMeetingHint.styl';
import {RepProfileTab} from '@store/coaching-plans';
import {browserHistory} from 'react-router';
import AuthStore from 'stores/AuthStore';
import CoachingTodo from 'records/CoachingTodo';
import CoachingParticipant from 'records/CoachingParticipant';
import CoachingReview from 'records/CoachingReview';
import {reviewPath} from 'components/dashboard/reviewPath';

interface Props {
  rep: CoachingParticipant;
  review: CoachingReview;
  todo: CoachingTodo;
}

const PlaylistPreviewMeetingHint = ({rep, review, todo}: Props) => {
  return (
    <div
      onClick={() =>
        browserHistory.push({
          pathname: reviewPath((AuthStore as any).getState().user),
          query: {
            tab: RepProfileTab.COACHING_PLANS,
            planId: review.planId,
            reviewId: review.id,
            repId: rep?.id,
            teamId: rep?.info?.teamId,
            // not autostarted
          },
        })
      }
      className={classNames('playlist-call-hint pointer', {
        done: todo?.callsToAdd === 0,
      })}>
      {<div>Preview Meeting</div>}
    </div>
  );
};

export default PlaylistPreviewMeetingHint;
